__turbopack_context__.v({
  "description": "bv3dcG_description",
});
